function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { addClass, removeClass } from '@bydesign-ui/hooks';
import { Emitter } from '@bydesign-ui/hooks';
import { shallowMerge } from '@bydesign-ui/utils';
import { calElemHitWithMousePos } from '../util';
var DEFAULT_OPTIONS = {
  containerIdentifierPropName: 'data-container-id',
  elemIdentifierPropName: 'data-element-id',
  hittingContainerClassName: '',
  mode: 'vertical',
  dragLimit: 10,
  isValidContainer: function isValidContainer() {
    return true;
  },
  isValidElement: function isValidElement() {
    return true;
  },
  isVirtualDrag: function isVirtualDrag() {
    return false;
  },
  createPlaceHolder: function createPlaceHolder() {
    return document.createElement('placeholder');
  },
  getContainerMode: function getContainerMode() {
    return null;
  },
  getDragRoot: function getDragRoot() {
    return document.body;
  }
};
export var Sortable = function (_Emitter) {
  _inherits(Sortable, _Emitter);

  var _super = _createSuper(Sortable);

  function Sortable() {
    var _this;

    _classCallCheck(this, Sortable);

    _this = _super.apply(this, arguments);
    _this.isDragging = false;
    _this.target = null;
    _this.root = null;
    _this.placeholder = null;
    _this.dragLimit = DEFAULT_OPTIONS.dragLimit;
    _this.containerIdentifierPropName = DEFAULT_OPTIONS.containerIdentifierPropName;
    _this.elemIdentifierPropName = DEFAULT_OPTIONS.elemIdentifierPropName;
    _this.isVirtualDrag = DEFAULT_OPTIONS.isVirtualDrag;
    _this.isValidContainer = DEFAULT_OPTIONS.isValidContainer;
    _this.isValidElement = DEFAULT_OPTIONS.isValidElement;
    _this.createPlaceHolder = DEFAULT_OPTIONS.createPlaceHolder;
    _this.getContainerMode = DEFAULT_OPTIONS.getContainerMode;
    _this.mode = DEFAULT_OPTIONS.mode;
    _this.getDragRoot = DEFAULT_OPTIONS.getDragRoot;
    _this.virtual = false;
    _this.lastHitContainer = null;
    _this.hittingContainerClassName = DEFAULT_OPTIONS.hittingContainerClassName;
    return _this;
  }

  _createClass(Sortable, [{
    key: "ensureDragRoot",
    value: function ensureDragRoot(e) {
      if (e.data == null) {
        return null;
      }

      return this.root = this.getDragRoot(e.data);
    }
  }, {
    key: "resetDragRoot",
    value: function resetDragRoot() {
      this.root = null;
    }
  }, {
    key: "getDragLimit",
    value: function getDragLimit() {
      return this.dragLimit;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var merged = shallowMerge(DEFAULT_OPTIONS, options);
      this.containerIdentifierPropName = merged.containerIdentifierPropName;
      this.elemIdentifierPropName = merged.elemIdentifierPropName;
      this.mode = merged.mode;
      this.isValidContainer = merged.isValidContainer;
      this.createPlaceHolder = merged.createPlaceHolder;
      this.isValidElement = merged.isValidElement;
      this.dragLimit = merged.dragLimit;
      this.getContainerMode = merged.getContainerMode;
      this.getDragRoot = merged.getDragRoot;
      this.isVirtualDrag = merged.isVirtualDrag;
      this.hittingContainerClassName = merged.hittingContainerClassName;
    }
  }, {
    key: "dragStart",
    value: function dragStart(e) {
      var data = e.data,
          target = e.target;

      if (data == null) {
        return;
      }

      this.target = target;
      this.isDragging = true;
      this.virtual = this.isVirtualDrag(data);
      this.emit('drag-start', e);
    }
  }, {
    key: "dragging",
    value: function dragging(e) {
      var data = e.data,
          target = e.target;

      if (data == null || !this.isDragging) {
        return;
      }

      if (target !== this.target) {
        this.resetDragInfo();
        return;
      }

      if (!this.virtual) {
        this.ensurePlaceHolderPosition(e);
      }

      this.emit('dragging', e);
    }
  }, {
    key: "dragEnd",
    value: function dragEnd(e) {
      var data = e.data,
          target = e.target;

      if (!data || this.target !== target || !this.isDragging || !this.virtual && this.placeholder == null) {
        this.resetDragInfo();
        return;
      }

      if (this.virtual) {
        this.resetDragInfo(e);
        return;
      }

      var to = this.getElementIndex(data, this.placeholder);
      var from = this.getElementIndex(data, target);

      if (to == null) {
        this.resetDragInfo();
        return;
      }

      this.resetDragInfo(e);
      var fromEvent = from ? _objectSpread({
        move: true,
        data: data
      }, from) : null;

      var toEvent = _objectSpread({
        move: from != null,
        data: data
      }, to);

      this.emit('change', e, fromEvent, toEvent);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.removePlaceholder();
    }
  }, {
    key: "ensurePlaceHolder",
    value: function ensurePlaceHolder(container, id, index, e) {
      this.removePlaceholder(container);
      return this.placeholder = this.createPlaceHolder(id, index, e);
    }
  }, {
    key: "removePlaceholder",
    value: function removePlaceholder(container) {
      if (this.lastHitContainer != null && this.hittingContainerClassName && container !== this.lastHitContainer) {
        removeClass(this.lastHitContainer, this.hittingContainerClassName);
      }

      this.lastHitContainer = null;

      if (this.placeholder && this.placeholder.parentNode) {
        this.placeholder.parentNode.removeChild(this.placeholder);
      }

      this.placeholder = null;
    }
  }, {
    key: "getHitContainer",
    value: function getHitContainer(data, target, currentMousePos) {
      var _this2 = this;

      var root = this.root,
          isValidContainer = this.isValidContainer,
          containerIdentifierPropName = this.containerIdentifierPropName;

      if (root == null) {
        return null;
      }

      var allElem = [].slice.call(root.querySelectorAll("[".concat(containerIdentifierPropName, "]")));
      allElem.push(root);
      allElem = allElem.filter(function (elem) {
        var id = elem.getAttribute(containerIdentifierPropName);

        if (id == null) {
          return false;
        }

        if (!isValidContainer(data, id)) {
          return false;
        }

        return elem !== target && !target.contains(elem) && elem !== _this2.placeholder;
      });
      allElem.sort(function (a, b) {
        var code = a.compareDocumentPosition(b);
        return code & 8 ? -1 : code & 16 ? 1 : code & 4 ? -1 : code & 2 ? 1 : 0;
      });

      var _iterator = _createForOfIteratorHelper(allElem),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var container = _step.value;
          var hitResult = calElemHitWithMousePos(container, currentMousePos);

          if (!hitResult) {
            continue;
          }

          var containerId = container.getAttribute(this.containerIdentifierPropName);
          var mode = this.getRealContainerMode(containerId);

          if (container !== root) {
            if (mode === 'vertical' && (hitResult.vertical === 'top' && hitResult.offsetTop <= 10 || hitResult.vertical === 'bottom' && hitResult.offsetBottom <= 10)) {
              continue;
            }

            if (mode === 'horizontal' && (hitResult.horizontal === 'left' && hitResult.offsetLeft <= 10 || hitResult.horizontal === 'right' && hitResult.offsetRight <= 10)) {
              continue;
            }
          }

          return _objectSpread({
            container: container,
            containerId: containerId,
            mode: mode
          }, hitResult);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "ensurePlaceHolderPosition",
    value: function ensurePlaceHolderPosition(e) {
      if (!this.isDragging) {
        return;
      }

      var data = e.data,
          target = e.target,
          currentMousePos = e.currentMousePos;

      if (!data) {
        return;
      }

      if (this.placeholder && calElemHitWithMousePos(this.placeholder, currentMousePos)) {
        return;
      }

      var result = this.getHitContainer(data, target, currentMousePos);

      if (!result) {
        this.removePlaceholder();
        return;
      }

      var container = result.container,
          containerId = result.containerId,
          mode = result.mode;

      if (this.hittingContainerClassName) {
        addClass(container, this.hittingContainerClassName);
      }

      var child = container.firstElementChild;
      var index = 0;
      var first = null;

      while (child) {
        if (child === target || child === this.placeholder) {
          child = child.nextElementSibling;
          continue;
        }

        var id = child.getAttribute(this.elemIdentifierPropName);

        if (id == null || !this.isValidElement(data, id)) {
          child = child.nextElementSibling;
          continue;
        }

        if (first == null) {
          first = child;
        }

        var hitResult = calElemHitWithMousePos(child, currentMousePos);

        if (hitResult) {
          var vertical = hitResult.vertical,
              horizontal = hitResult.horizontal;

          if (mode === 'vertical' && vertical === 'top' || mode === 'horizontal' && horizontal === 'left') {
            container.insertBefore(this.ensurePlaceHolder(container, containerId, index, e), child);
          } else {
            container.insertBefore(this.ensurePlaceHolder(container, containerId, index, e), child.nextSibling);
          }

          this.lastHitContainer = container;
          return;
        }

        child = child.nextElementSibling;
        index++;
      }

      container.appendChild(this.ensurePlaceHolder(container, containerId, index, e));
      this.lastHitContainer = container;
    }
  }, {
    key: "getElementIndex",
    value: function getElementIndex(data, element) {
      if (!element) {
        return null;
      }

      var index = 0;
      var parent = element.parentNode;

      if (!parent) {
        return null;
      }

      var container = parent.getAttribute(this.containerIdentifierPropName);

      if (!container) {
        return null;
      }

      for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
        if (child === element) {
          break;
        }

        var id = child.getAttribute(this.elemIdentifierPropName);

        if (id == null || !this.isValidElement(data, id)) {
          continue;
        }

        if (child !== this.target) {
          index++;
        }
      }

      return {
        container: container,
        index: index
      };
    }
  }, {
    key: "resetDragInfo",
    value: function resetDragInfo(e) {
      this.virtual = false;
      this.isDragging = false;
      this.target = null;
      this.resetDragRoot();
      this.removePlaceholder();

      if (e == null) {
        this.emit('drag-cancel');
        return;
      }

      this.emit('drag-end', e);
    }
  }, {
    key: "getRealContainerMode",
    value: function getRealContainerMode(id) {
      var mode = this.getContainerMode(id);
      return mode == null ? this.mode : mode;
    }
  }]);

  return Sortable;
}(Emitter);